import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

const RadioButton = (props) => {
  const [checked, setChecked] = useState(props.checked)
  const action = props.action
  const name = props.name

  const radio = useRef()

  const handleOnChange = () => {
  };
  const handleClick = () => {
    if (!checked) {
      radio.current.click()
      if (action) action(!checked, name);
      setChecked(!checked)
    }
  }
  useEffect(() => {
    setChecked(props.checked)
  }, [props.checked])

  return (
    <div className={`mb-3 ${props.customQuestionComponentClass}`}>
      <div className="flex items-center mr-4">
        <input ref={radio} id={props.id} type="radio" checked={checked} name={name} className="hidden" onChange={handleOnChange} />
        <label htmlFor={props.id} className="flex items-center cursor-pointer text-gray-700">
          <span className={`w-6 h-6 inline-block mr-4 rounded-full border border-grey text-center ${checked ? 'bg-primary-orange' : ''}`} onClick={handleClick}>
            {!!checked && <i className="text-white fa fa-check" aria-hidden="true"></i>}
          </span>
          {props.label}
        </label>
      </div>
    </div>
  );
};

RadioButton.defaultProps = {
  customQuestionComponentClass: '',
}

RadioButton.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  customQuestionComponentClass: PropTypes.string,
  action: PropTypes.func,
  checked: PropTypes.bool,
  name: PropTypes.string
}

export default RadioButton;
